<template>
    <div :class="['popup_basic01', this.selState ? 'ss close' : 'ss open']" :style="selectedLfcnvncTab == 'hosPhar' ? '' : 'display:none;'">
        <div class="popup_wrap2 he280">
            <div class="sel_area">
                <!-- <h2 class="optionT" @click.prevent="closeSelState()">닫기</h2> -->
                <div class="sel_control">
                    <a class="lfcvnc" href="javascript:void(0);" @click.prevent="closeSelState()">접기</a>
                </div>


                <div class="item_area gnmap pdt-10">
                    <div class="item_sel">
                        <button :class="['tablinks', selectedHpCate == btn.commonCode ? 'active' : '']" v-for="btn in hpCateList" @click.prevent="selectLfcnvncHp(btn.commonCode)">{{ btn.commonCodeNm }}</button>
                        <!-- <div class="txt">현재운영중</div> -->
                        <div class="txt">현재 휴무</div>
                    </div>

                    <!-- <div id="" class="tabcontent ps-01">
                        <template v-if="Object.keys(hpCateMap).length > 0">
                            <label class="contain" v-for="(submenu, index) in hpCateMap[selectedHpCate].codeList" :key="selectedHpCate + submenu.commonCode">
                                <input type="checkbox" ref="lfcnvnc-item-checkboxes"
                                :name="'lfcnvnc_' + submenu.commonCode"
                                :data-index="submenu.commonCode"
                                :data-name="submenu.commonCodeNm"
                                :value="submenu.commonCode"
                                @click="selectHpSubCate(submenu)"><span :class="['checkmark i04-' + submenu.commonCodeEngNm]"></span>{{ submenu.commonCodeNm }}
                                ({{ setListLength(submenu.commonCode) }}개)
                            </label>
                            <label class="contain" v-if="selectedHpCate == 'LFCNVNC_02'">&nbsp;</label>
                            <label class="contain" v-if="selectedHpCate == 'LFCNVNC_02'">&nbsp;</label>
                        </template>
                    </div> -->

                    <div id="" class="tabcontent ps-01" v-show="this.selectedHpCate == 'LFCNVNC_01'">
                        <label class="contain" v-for="(submenu, index) in hCateList" :key="selectedHpCate + submenu.commonCode">
                            <input type="checkbox" ref="hos-item-checkboxes"
                            :name="'hos_' + submenu.commonCode"
                            :data-index="submenu.commonCode"
                            :data-name="submenu.commonCodeNm"
                            :value="submenu.commonCode"
                            :key="submenu.commonCode"
                            @click="selectHosSubCate(submenu)"><span :class="['checkmark i04-' + submenu.commonCodeEngNm]"></span>{{ submenu.commonCodeNm }}
                            ({{ setListLength(submenu.commonCode) }}개)
                        </label>
                    </div>

                    <div id="" class="tabcontent ps-01" v-show="this.selectedHpCate == 'LFCNVNC_02'">
                        <label class="contain" v-for="(submenu, index) in pCateList" :key="selectedHpCate + submenu.commonCode">
                            <input type="checkbox" ref="phar-item-checkboxes"
                            :name="'phar_' + submenu.commonCode"
                            :data-index="submenu.commonCode"
                            :data-name="submenu.commonCodeNm"
                            :value="submenu.commonCode"
                            :key="submenu.commonCode"
                            @click="selectPharSubCate(submenu)"><span :class="['checkmark i04-' + submenu.commonCodeEngNm]"></span>{{ submenu.commonCodeNm }}
                            ({{ setListLength(submenu.commonCode) }}개)
                        </label>
                        <!-- <label class="contain">&nbsp;</label> -->
                        <label class="contain">&nbsp;</label>
                    </div>
                    <div class="clear"></div>
                </div>

                <div class="sel_option" v-if="selState">
                    <p class="sel_tit">선택한 옵션 적용</p>
                    <p class="sel_icon">
                        <a :style="$_WC.isMobile ? 'width: 100%;' : ''" href="javascript: void(0);" class="on" @click.prevent="closeSelState()"><i class="sel_i12"></i>
                            병의원·약국 
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_WC, $_TYPE } from '@/confs/common.const.js';

export default {
    data() {
        return {
            selState: false,
            arr: [],
        }
    },
    components: {
    },
    watch: {
        // selectedLfcnvncTab: {
        //     immediate: true,
        //     handler(newVal, oldVal) {
        //         if(newVal == 'hosPhar') {
        //             // 탭 선택 시 초기 설정 값(야간병의원)
        //             this.$store.dispatch('SET_SELECTED_HP_CATE', 'LFCNVNC_01');
        //         }
        //     }
        // },
        selectedHpCate: {
            immediate: false,
            handler(newVal, oldVal) {
                // 열려진 창을 닫는다
                if(typeof this.curInfoWindow !== $_TYPE.UNDEF) {
                    this.curInfoWindow.close();
                }
                this.$nextTick(() =>{
                    if(newVal == 'LFCNVNC_01') {
                        this.initSelectHpSubCate();
                    } else {
                        this.initSelectPharSubCate();
                    }
                });
            }
        },
    },
    computed: {
        ...mapGetters({
            hpCateList: 'getHpCateList',
            selectedHpCate: 'getSelectedHpCate',
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
            // hpCateMap: 'getHpCateMap',
            hCateList: 'getHCateList',
            pCateList: 'getPCateList',
            selectedLfcnvncItems: 'getSelectedLfcnvncItems',
        }),
    },
    mounted() {
        this.$eventBus.$on('LfcnvncApp::loaded-data',() => {
            this.initSelectHpSubCate();
        });
    },
    methods: {
        selectLfcnvncHp(code) {
            this.$store.dispatch("SET_SELECTED_HP_CATE", code);
        },
        initSelectHpSubCate() {
            let lfcnvncItemCheckboxes = this.$refs['hos-item-checkboxes'];
            lfcnvncItemCheckboxes.forEach((chkbox, idx) => {
                if(idx == 0) {
                    chkbox.checked = true;
                }
            });
            this.selectHosSubCate(this.hCateList[0]);
            // if(typeof this.hpCateMap['LFCNVNC_01'] != 'undefined') {
            //     if(!!this.hpCateMap['LFCNVNC_01'].codeList) {
            //         this.selectHpSubCate(this.hpCateMap['LFCNVNC_01'].codeList[0]);
            //     }
            // }
        },
        initSelectPharSubCate() {
            let lfcnvncItemCheckboxes = this.$refs['phar-item-checkboxes'];
            lfcnvncItemCheckboxes.forEach((chkbox, idx) => {
                if(idx == 0) {
                    chkbox.checked = true;
                }
            });
            this.selectPharSubCate(this.pCateList[0]);
        },
        selectHosSubCate(submenu) {
            let lfcnvncItemCheckboxes = this.$refs['hos-item-checkboxes'];
            
            let lfcnvncChkState = [];
    
            lfcnvncItemCheckboxes.forEach((chkbox)=>{
                if(chkbox.value == submenu.commonCode) {
                    chkbox.checked = true;
                } else {
                    chkbox.checked = false;
                }
                lfcnvncChkState.push({
                    id: chkbox.id,
                    dataKdSqno: chkbox.value,
                    checked: chkbox.checked,
                    index: chkbox.attributes['data-index'].value,
                    name: chkbox.attributes['data-name'].value,
                    // 마지막 선택 여부
                    lastChecked: (chkbox.checked &&  chkbox.value == submenu.commonCode),
                });
            });
            this.$store.dispatch('SET_SELECTED_LFCNVNC_ITEMS', lfcnvncChkState);
        },
        selectPharSubCate(submenu) {
            let lfcnvncItemCheckboxes = this.$refs['phar-item-checkboxes'];
            
            let lfcnvncChkState = [];
    
            lfcnvncItemCheckboxes.forEach((chkbox)=>{
                if(chkbox.value == submenu.commonCode) {
                    chkbox.checked = true;
                } else {
                    chkbox.checked = false;
                }
                lfcnvncChkState.push({
                    id: chkbox.id,
                    dataKdSqno: chkbox.value,
                    checked: chkbox.checked,
                    index: chkbox.attributes['data-index'].value,
                    name: chkbox.attributes['data-name'].value,
                    // 마지막 선택 여부
                    lastChecked: (chkbox.checked &&  chkbox.value == submenu.commonCode),
                });
            });
            this.$store.dispatch('SET_SELECTED_LFCNVNC_ITEMS', lfcnvncChkState);
        },
        setListLength(code) {
            let listNm = code + 'List';
            listNm = listNm.charAt(0).toUpperCase() + listNm.substring(1, listNm.length);
            let list = this.$store.getters['get'+listNm];
            return list.length;
        },
        closeSelState() {
            this.selState = !this.selState;
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
